"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickAccess = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
exports.QuickAccess = function (_a) {
    var sections = _a.sections;
    return (react_1.default.createElement("div", { className: "quick-access-wrapper" },
        react_1.default.createElement(core_1.Grid, { spacing: 3, container: true }, sections === null || sections === void 0 ? void 0 : sections.actions.map(function (v, i) { return (react_1.default.createElement(core_1.Grid, { item: true, xs: 3, key: i },
            v.value && (react_1.default.createElement(core_1.Badge, { anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, 
                // className={!v.value && 'display-none'}
                color: "primary", badgeContent: v.value })),
            react_1.default.createElement("div", __assign({ className: "card" }, v.props),
                react_1.default.createElement("img", { src: v.icon, width: 40, height: 40, srcSet: v.icon, loading: "lazy" })),
            react_1.default.createElement("div", { className: "fs-12 fw-medium label" }, v.label))); }))));
};
//# sourceMappingURL=QuickAccess.js.map